import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class SiteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      siteName: '',
      siteAddress: '',
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
      SiteName: this.state.siteName,
      SiteAddress: this.state.siteAddress,
    };

    if (!this.props.data.isEdit) {
      axios
        .post(url + ':3000/v1/site/create', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }

          this.props.closeModal(
            <MdDone />,
            'New site added successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    } else {
      data.SiteID = this.props.data.siteId;
      axios
        .post(url + ':3000/v1/site/update', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }

          this.props.closeModal(
            <MdDone />,
            'Site updated successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    }
  };

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.siteId;
      const site = this.props.data.siteList.find(e => e.SiteID === id);
      this.setState({
        siteName: site.SiteName,
        siteAddress: site.SiteAddress,
      });
    }
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Site Information
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="siteName">Site Name</Label>
                <Input
                  type="text"
                  name="siteName"
                  value={this.state.siteName}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="siteAddress">Site Address</Label>
                <Input
                  type="textarea"
                  name="siteAddress"
                  value={this.state.siteAddress}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            {this.props.data.isEdit ? 'Save' : 'Add Site'}
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default SiteForm;
